const packageConsts = {
    BASIC_PAC_ID: '-3',
    PERM_UNASSIGNED_PAC_ID: '-1',
    NO_PACKAGE: '0'
};

export default packageConsts;
